import React from "react";
import Head from "next/head";
import DirectServiceLandingPage from "~/components/DirectServiceLandingPage";

const DirectService: React.FC = () => {
    return (
        <>
            <Head>
                <title>Fotógrafo profissional para festas, ensaios, eventos e etc - Fotop Serviços Direto</title>
            </Head>
            <DirectServiceLandingPage />
        </>
    );
};

export default DirectService;
